import React from 'react';
import classNames from 'classnames';
import cookies from 'react-cookies';
import { withRouter } from 'react-router-dom';

import { connectTo } from '../../utils';
import {
  getAvailableLanguages,
  logout,
  selectBrowserLanguage,
  selectLanguage
} from '../../actions';
import * as routes from '../../constants/routes';

import {
  CookieAgreement,
  Footer,
  Header
} from '../../components/main/index.troy';

import { GTM_COOKIE_NAME, initializeTagManager } from '../../config/gtm';

import styles from './index.module.scss';

const cookieHideKey = GTM_COOKIE_NAME;

class MainLayout extends React.Component {
  state = {
    hideAgreement: cookies.load(cookieHideKey),
    isTagManagerInitialized: false,
    isBrowserLanguageSent: false
  };

  componentDidMount() {
    const { getAvailableLanguages, availableLanguages } = this.props;

    if (!availableLanguages) {
      getAvailableLanguages();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      availableLanguages,
      selectBrowserLanguage,
      isAuthenticated,
      reLoginMode
    } = this.props;
    const {
      isBrowserLanguageSent,
      hideAgreement,
      isTagManagerInitialized
    } = this.state;

    if (
      !reLoginMode &&
      !isAuthenticated &&
      !isBrowserLanguageSent &&
      availableLanguages
    ) {
      selectBrowserLanguage({ isAuthenticated, languages: availableLanguages });
      this.setState({
        isBrowserLanguageSent: true
      });
    }

    if (!isTagManagerInitialized && hideAgreement) {
      initializeTagManager();
      this.setState({ isTagManagerInitialized: true });
    }
  }

  onLogout = () => {
    const { logout } = this.props;
    logout();
  };

  onCookieClick = () => {
    this.setState({ hideAgreement: true });
    cookies.save(cookieHideKey, true);
  };

  onLanguageSelect = newCode => {
    const { selectLanguage, isAuthenticated } = this.props;
    selectLanguage({ code: newCode, isAuthenticated });
  };

  render() {
    const {
      children,
      isAuthenticated,
      availableLanguages,
      language,
      logout,
      hasStaticTexts,
      location
    } = this.props;
    const { hideAgreement } = this.state;

    // login page do not show skeletons
    if (
      !isAuthenticated &&
      [routes.HOME, routes.LOGIN].includes(location.pathname) &&
      !hasStaticTexts
    ) {
      return null;
    }

    return (
      <div
        className={classNames(
          styles['main-layout__wrapper'],
          isAuthenticated && styles['main-layout__wrapper-mobile-padding']
        )}
      >
        <Header
          isAuthenticated={isAuthenticated}
          onLogout={this.onLogout}
          languages={availableLanguages}
          onLanguageSelect={this.onLanguageSelect}
          language={language}
        />
        {children}
        <Footer isAuthenticated={isAuthenticated} logout={logout} />
        <CookieAgreement open={!hideAgreement} onOkClick={this.onCookieClick} />
      </div>
    );
  }
}

export default withRouter(
  connectTo(
    ({ translations: { availableLanguages, language, hasStaticTexts } }) => ({
      availableLanguages,
      language,
      hasStaticTexts
    }),
    { logout, getAvailableLanguages, selectLanguage, selectBrowserLanguage },
    MainLayout
  )
);
